module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p'), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_vm._v("For Stacia, ")]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_vm._v("without whose constant support")]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_vm._v("and encouragement this book ")]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_vm._v("never would have happened.")]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_vm._v("And for Elizabeth North:")]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_vm._v("Thank you for being a constant source ")]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_vm._v("of light when all the others disappeared.")]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_vm._v("A special thank you to Mickie B. Ashling, ")]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_vm._v("Zahra Owens, and Christopher Koehler ")]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_vm._v("for giving so freely of their time and expertise.")]), _vm._v(" "), _c('p')])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1afeef34","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006.vue
// module id = 69
// module chunks = 0